module.exports = __webpack_public_path__ + "static/media/07.2da5e323.jpg";